/**
 * Created by BFR on 18/02/2020.
 */
define('pimProductEditsTabView',[
  'module',
  'app',
  'jquery',
  'windows',
  'marionette',
  'underscore',
  'bootbox',
  'dynamicTextView',
  'template!pimProductEditsTabTpl',
  'editPimCatsView',
  'editPimImageView',
  'pimProductDetailImagesView',
  'editPimPrintAreasView',
  'editPimVariationsView',
  'editPimPrintVariationsView',
  'pimPicturePositionerLauncher',
  'pimUtil',
  'settings',
  'productEditsTabView',
  'contextMenu',
  'entities/product_rel'
], function (
  module,
  App,
  $,
  Windows,
  Marionette,
  _,
  bootbox,
  DynamicTextView,
  viewTpl,
  EditPimCatsView,
  EditPimImageView,
  PimProductDetailImagesView,
  EditPimPrintAreasView,
  EditPimVariationsView,
  EditPimPrintVariationsView,
  PositionerLauncher,
  PimUtil,
  Settings,
  ProductView
) {
  'use strict';

  var PimProductEditsView = Marionette.LayoutView.extend({
    template: viewTpl,
    className: 'overview',

    regions: {
      nameRegion: '.name-region',
      editCats: '.edit-cats',
      editPrintAreas: '.edit-printareas',
      editImage: '.edit-image',
      imagesRegion: '.images-region',
      editVariations: '.edit-variations'
    },

    ui: {
      blockLoading: '.js-loading-block'
    },

    events: {
      'click .btn-generate-textile-pas': 'onGeneratePaClick',
      'click .btn-edit-supplier-product': 'onEditSupplierProductClick',
      'click .btn-force-update-compuzz-product': 'onEditForceUpdateCompuzzProductClick',
      'click .btn-save-options-categories': 'onBtnSaveOptionsCategoriesClick',
      'click .btn-position-areas': 'onPositionAreasClick'
    },

    onEditSupplierProductClick: function () {

      if (this.model.get('compuzzProductSecId')) {
        this.fetchCompuzzProduct();
      } else {
        this.ui.blockLoading.show();
        this.model.createCompuzzProduct().done(_.bind(function () {
          if (this.model.get('compuzzProductSecId')) {
            this.fetchCompuzzProduct();
          } else {
            bootbox.alert('Unable to create the supplier product');
          }
          this.ui.blockLoading.hide();
        }, this));
      }
    },

    onEditForceUpdateCompuzzProductClick: function () {
      bootbox.confirm(_.i18n('common.forceUpdateCompuzzProductConfirm'), _.bind(function (result) {
        if (result) {
          this.ui.blockLoading.show();
          this.model.createCompuzzProduct(true).done(_.bind(function () {
            if (this.model.get('compuzzProductSecId')) {
              this.fetchCompuzzProduct();
            } else {
              bootbox.alert('Unable to update the supplier product');
            }
            this.ui.blockLoading.hide();
          }, this));
        }
      }, this));
    },

    fetchCompuzzProduct: function () {
      var product = App.request('products-rel:model', {secId: this.model.get('compuzzProductSecId')});
      var productFetch = product.fetch();

      $.when(productFetch).done(_.bind(function () {
        var pView = new ProductView({
          model: product
        });
        pView.el.className += ' tab-layout-content';
        Windows.open({
          view: _.bind(function () {
            return pView;
          }, this),
          id: 'history:order:' + product.get('secId'),
          title: 'Supplier edit product : ' + product.get('code'),
          configName: 'fullScreen',
          bodyClass: 'product-page'
        });
      }, this));
    },

    onRender: function () {
      this.editPimCatsView = new EditPimCatsView({
        pimProduct: this.model,
        collection: this.model.get('data').get('productOptionCategories')
      });

      this.getRegion('editCats').show(this.editPimCatsView);

      // A PRINT product has no print area, the template has no place for them
      if (!this.isPrintProduct()) {
        this.editPimPrintAreasView = new EditPimPrintAreasView({
          pimProduct: this.model,
          collection: this.model.get('data').get('printAreas')
        });

        this.getRegion('editPrintAreas').show(this.editPimPrintAreasView);
      }

      this.editPimImageView = new EditPimImageView({model: this.model});
      this.getRegion('editImage').show(this.editPimImageView);

      //----------------
      this.imagesView = new PimProductDetailImagesView({model: this.model});
      this.getRegion('imagesRegion').show(this.imagesView);


      if (this.isPrintProduct()) {
        // Thousands of combinations: a paged table, not one view per variation
        this.editVariationsView = new EditPimPrintVariationsView({pimProduct: this.model});
        this.getRegion('editVariations').show(this.editVariationsView);
        return;
      }

      var variationsCol = this.model.get('data').get('productCodeVariations');
      this.editVariationsView = new EditPimVariationsView({
        pimProduct: this.model,
        pimProductId: this.model.get('id'),
        pimSupplierData: this.model.get('supplierData'),
        collection: variationsCol
      });
      this.getRegion('editVariations').show(this.editVariationsView);
    },

    onShow: function () {
      var that = this;
      this.$el.contextMenu({
        selector: '.context-menu-pz',
        callback: function () {
        },
        items: {
          image: {
            name: 'Use as catalogue picture',
            callback: function () {
              that.selectImage(this.find('img').attr('data-link'));
            }
          }
        },
        trigger: 'right'
      });

      // The product's own pictures, in the gallery.
      this.$el.contextMenu({
        selector: '.pim-products-details-image-view',
        items: {
          image: {
            name: 'Use as catalogue picture',
            callback: function () {
              that.selectImage(this.find('img').attr('src'));
            }
          },
          position: {
            name: _.i18n('pimPositioner.open', null, 'Position print areas'),
            callback: function () {
              that.openPositioner(this.find('img').attr('src'));
            }
          }
        },
        trigger: 'right'
      });

      this.$el.contextMenu({
        selector: '.context-menu-option',
        callback: function () {
        },
        items: {
          image: {
            name: 'Use as catalogue picture',
            callback: function () {
              that.selectImage(this.data('link'));
            }
          },
          setDefault: {
            name: 'Set as default',
            callback: function () {
              that.setDefaultImage(this.data('index'));
            }
          },
          position: {
            name: _.i18n('pimPositioner.open', null, 'Position print areas'),
            callback: function () {
              that.openPositioner(this.data('link'));
            }
          },
          // Handled by the option's view (EditPimOptionView), which owns the upload
          replaceImage: {
            name: _.i18n('pimOptionImage.replace', null, 'Replace with my image'),
            callback: function () {
              this.trigger('pim:option-image:replace');
            }
          },
          deleteImage: {
            name: _.i18n('pimOptionImage.delete', null, 'Delete my image'),
            visible: function () {
              return !!$(this).data('uid');
            },
            callback: function () {
              this.trigger('pim:option-image:delete');
            }
          }
        },
        trigger: 'right'
      });
    },

    onPositionAreasClick: function () {
      this.openPositioner(null);
    },

    /**
     * Places the print areas on the product's pictures, for this reseller.
     * Opened on a given picture when one was right-clicked, on picture 1 of
     * the first option otherwise. Saving redraws the sheet, so the badges on
     * the pictures say what was just placed.
     */
    openPositioner: function (startUrl) {
      PositionerLauncher.open(this.model, startUrl, _.bind(function () {
        if (!this.isDestroyed) {
          this.render();
        }
      }, this));
    },

    serializeData: function () {
      var templateData = this.model.toJSON();
      templateData.allowEditCompuzz = !!Settings.configValue('allowEditSupplierProduct');
      //-------------
      templateData.name = '';
      _.each(templateData.data.name.values, function (value, lang) {
        if (Settings.get('lang')) {
          if (lang === Settings.get('lang')) {
            templateData.name = value;
          }
        }
      });
      templateData.description = '';
      if (templateData.data.description) {
        _.each(templateData.data.description.values, function (value, lang) {
          if (Settings.get('lang')) {
            if (lang === Settings.get('lang')) {
              templateData.description = value;
            }
          }
        });
      }
      templateData.attachments = this.getAttachments(templateData.data.attachments);
      templateData.isPrint = this.isPrintProduct();
      templateData.printSummary = templateData.isPrint ? this.getPrintSummary() : null;
      return templateData;
    },

    /**
     * A configurable print product (FLYERALARM...): no print area, the option
     * categories are the steps of the webshop configurator and the variations
     * the valid combinations, each with its production template.
     */
    isPrintProduct: function () {
      return this.model.get('data').get('productType') === 'PRINT';
    },

    getPrintSummary: function () {
      var data = this.model.get('data'),
        variations = data.get('productCodeVariations').models;
      return {
        steps: _.chain(data.get('productOptionCategories').models)
          .sortBy(function (poc) {
            return poc.get('displayOrder') || 0;
          })
          .map(function (poc) {
            var values = poc.get('name') ? poc.get('name').get('values') : null;
            return {
              name: (values && (values[Settings.get('lang')] || values.en || _.values(values)[0])) || poc.get('code'),
              count: poc.get('productOptions').length
            };
          })
          .value(),
        combinations: variations.length,
        withTemplate: _.filter(variations, function (pcv) {
          return !!pcv.get('templateUrl');
        }).length
      };
    },

    /**
     * The supplier's documents (data sheets, manuals, certificates...) brought
     * in by the importer: only their name and URL, the files stay on the
     * supplier's side.
     */
    getAttachments: function (attachments) {
      var imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp'];
      return _.chain(attachments || [])
        .filter(function (att) {
          return att && att.fileUrl;
        })
        .map(function (att) {
          var path = att.fileUrl.split(/[?#]/)[0],
            name = att.fileName,
            dot = path.lastIndexOf('.'),
            extension = dot > path.lastIndexOf('/') ? path.substring(dot + 1).toLowerCase() : '';
          if (!name) {
            name = path.substring(path.lastIndexOf('/') + 1);
            try {
              name = decodeURIComponent(name);
            } catch (e) {
              // Badly encoded URL: keep the raw file name
            }
            name = name || att.fileUrl;
          }
          return {
            name: name,
            url: att.fileUrl,
            extension: extension.toUpperCase(),
            isImage: _.contains(imageExtensions, extension)
          };
        })
        .sortBy(function (att) {
          return att.name.toLowerCase();
        })
        .value();
    },

    /*onGeneratePaClick: function () {
      $('.js-loading-block').show();
      var updateDataRequest = App.request('products:generate-printareas', this.options.model.get('secId'), 'textile');
      $.when(updateDataRequest).done(_.bind(function () {
        $('.js-loading-block').hide();
        this.trigger('product-overview:reload');
      }, this));
    },*/

    setDefaultImage: function (index) {
      this.model.getCurrentResProduct().set('defaultIndexPicture', index);
      $.when(this.model.getCurrentResProduct().save()).done(_.bind(function () {
        this.editPimCatsView.render();
      }, this));
    },

    selectImage: function (url) {

      var formData = new FormData(),
        productRequest;

      var fd = {};

      fd.imageUrl = url;

      _.each(fd, function (value, key) {
        formData.append(key, value);
      });

      productRequest = App.request('pim:products:update-catalog-picture-from-url', this.model.getCurrentResProduct().get('id'), formData);
      $.when(productRequest)
        .done(_.bind(function (response) {
          this.model.getCurrentResProduct().set('catalogPictureUid', response.catalogPictureUid);
          //this.editPimImageView.render();
        }, this))
        .fail(_.bind(function () {
          this.editPimImageView.render();
        }, this));
    },

    onBtnSaveOptionsCategoriesClick: function () {

      var productOptionCategories = [];

      _.each(this.model.get('data').get('productOptionCategories').models, _.bind( function (poc){
        var productOptionCategory = {
          pimId: poc.get('pimId'),
          productOptions: [],
          mixable: poc.get('mixable')
        };
        _.each(poc.get('productOptions').models, _.bind( function (poco){
          productOptionCategory.productOptions.push({
            pimId: poco.get('pimId'),
            activated: poco.get('activated')
          });
        }, this));
        productOptionCategories.push(productOptionCategory);
      }, this));

      this.model.getCurrentResProduct().set('pimPoResellers', productOptionCategories);

      this.ui.blockLoading.show();

      var p1 = this.model.getCurrentResProduct().saveOptionsCategories();


      $.when(p1).done(_.bind(function () {
        this.ui.blockLoading.hide();
        this.render();// Refresh the variations
      }, this));
    }
  });

  module.exports = PimProductEditsView;
});
